import React, { useState } from 'react';
import { PageTemplateProps } from 'types';
import { POSTS_PER_PAGE, INITIAL_PAGE } from '../constants';

export const useBuildTabContent = (
  content: PageTemplateProps['pressReleases'] | PageTemplateProps['mediaArticles'],
) => {
  const sortedContent = content.sort((a, b) => {
    const aPublishDate = a.publishDate || a.publication_date || a.publish_details.time;
    const bPublishDate = b.publishDate || b.publication_date || b.publish_details.time;

    return new Date(bPublishDate).getTime() - new Date(aPublishDate).getTime();
  });

  const [tabContent, setTabContent] = useState<
    PageTemplateProps['pressReleases'] | PageTemplateProps['mediaArticles']
  >(sortedContent.slice(0, POSTS_PER_PAGE));
  const [currentPage, setCurrentPage] = useState(INITIAL_PAGE);

  const handlePaginationPage = (_: React.ChangeEvent, page: number) => {
    const getContentSlice = (pageNum: number) => {
      const startIndex = (pageNum - 1) * POSTS_PER_PAGE;
      return sortedContent.slice(startIndex, startIndex + POSTS_PER_PAGE);
    };

    const scrollToTabList = () => {
      document?.querySelector('[role="tablist"]')?.scrollIntoView({
        behavior: 'smooth',
      });
    };

    setCurrentPage(page);
    setTabContent(getContentSlice(page));
    scrollToTabList();
  };

  return {
    tabContent,
    currentPage,
    handlePaginationPage,
  };
};
